import CDS from "design-system";
import { useMarkCompleteTask } from "features/Resources/Task/hooks";
import { Task } from "features/Resources/Task/models";

interface MarkCompleteToggleButtonProps {
  task: Task;
  onSuccess?: (res: any) => void;
}

export default function MarkCompleteToggleButton({ task, onSuccess = () => {} }: MarkCompleteToggleButtonProps) {
  const markComplete = useMarkCompleteTask(task, onSuccess);

  if (task?.status === "skipped") {
    return null;
  }
  if (task?.status === "completed") {
    return (
      <CDS.Button
        intent={CDS.Button.intent.primary}
        size="sm"
        onClick={() => markComplete()}
      >
        Re-Open
      </CDS.Button>
    );
  }
  return (
    <CDS.Button
      intent={CDS.Button.intent.primary}
      variant={CDS.Button.variant.solid}
      size="sm"
      onClick={() => markComplete()}
    >
      Mark Complete
    </CDS.Button>
  );
}
